module.exports = __webpack_public_path__ + "img/SAVE_PAY.09bd88c4.svg";